import React from 'react';
import { Button, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

const OPERATION_ICONS = new Map([['workflow.node.retry', <ReloadOutlined />]]);

export default function WorkflowOperationActions({
  actions = [],
  onWorkflowOperationAction,
  themeTokens,
}) {
  const visibleActions = (Array.isArray(actions) ? actions : [])
    .filter((action) => action && typeof action === 'object' && !Array.isArray(action));
  if (!visibleActions.length || typeof onWorkflowOperationAction !== 'function') {
    return null;
  }
  return (
    <Space className="flare-thinking-process-actions" size={4} wrap>
      {visibleActions.map((action) => (
        <Button
          disabled={action.disabled === true}
          key={String(action.action_key || action.operation_type || action.label)}
          loading={action.pending === true}
          icon={OPERATION_ICONS.get(action.operation_type)}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onWorkflowOperationAction(action);
          }}
          size="small"
          type="text"
          style={{ color: themeTokens.textSecondary, paddingInline: 4 }}
        >
          {String(action.label || action.operation_type || '操作')}
        </Button>
      ))}
    </Space>
  );
}
